<!--
 * @Author: your name
 * @Date: 2021-06-22 13:58:41
 * @LastEditTime: 2021-06-23 11:26:01
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\views\dataIndex\components\EcTag.vue
-->
<template>
  <div class="ec-tag">
    <div class="ec-tag__txt">
       {{tagTxt}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'EcTag',
  props: {
    tagTxt: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.ec-tag {
  &__txt {
    font-size: 10px;
    border: 1px solid #00ffe4;
    background:rgba(0, 255, 228, 0.25);
    color: #00ffe4;
    padding: 0px 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataIndex/components/EcTag.vue